/**
 * Challenge card – pick cells and other-participant picks section.
 * Composed by challengeCardMatches.styles.ts.
 */

import { Platform } from 'react-native';
import { makeBoxShadow } from '../../shared/helpers/shadowStyles.helper';
import type { Theme } from '../../theme/getTheme';
import { CHALLENGE_CARD_WIDE_INNER_MAX_WIDTH } from '../constants/challengeCardLayout.constants';

export function getChallengeCardPickCellsStyles(theme: Theme): Record<string, object> {
  return {
    pickCell: {
      width: 72,
      minWidth: 72,
      minHeight: 52,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.background.card,
      borderRadius: 10,
      borderWidth: 1.5,
      borderColor: theme.primary,
      paddingVertical: 8,
      paddingHorizontal: 6,
      position: 'relative' as const,
    },
    pickCellWide: {
      width: 88,
      minWidth: 88,
      minHeight: 56,
      paddingVertical: 10,
      paddingHorizontal: 8,
    },
    pickCellCorrect: {
      borderColor: theme.success,
      backgroundColor: theme.background.card,
    },
    pickCellWrong: {
      borderColor: theme.error,
      backgroundColor: theme.background.card,
    },
    pickCellCheckWrap: {
      position: 'absolute' as const,
      top: 4,
      right: 4,
      zIndex: 1,
    },
    pickCellLabel: {
      fontSize: 10,
      fontWeight: '600',
      color: theme.black,
      marginBottom: 2,
      textAlign: 'center',
    },
    pickCellOdds: {
      fontSize: 14,
      fontWeight: '800',
      color: theme.accentDark,
      textAlign: 'center',
    },
    pickCellLabelWrong: {
      fontSize: 10,
      fontWeight: '600',
      color: theme.black,
      marginBottom: 2,
      textAlign: 'center',
    },
    pickCellOddsWrong: {
      fontSize: 14,
      fontWeight: '800',
      color: theme.accentDark,
      textAlign: 'center',
    },
    pickCellUnknown: {
      fontSize: 18,
      fontWeight: '700',
      color: theme.gray[600],
      textAlign: 'center',
    },
    pickCellPressed: {
      opacity: 0.7,
    },
    picksCardInner: {
      maxWidth: CHALLENGE_CARD_WIDE_INNER_MAX_WIDTH,
      alignSelf: 'center' as const,
      width: '100%' as const,
    },
    matchOnlyOtherHeader: {
      paddingVertical: 8,
      paddingHorizontal: 10,
      backgroundColor: theme.background.card,
      borderRadius: 10,
      borderLeftWidth: 4,
      borderLeftColor: theme.primary,
    },
    matchOnlyOtherTeams: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.black,
    },
    otherPicksSection: {
      marginTop: 0,
      padding: 10,
      backgroundColor: theme.background.card,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.gray[300],
      gap: 0,
    },
    otherPicksLabelRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      marginBottom: 6,
    },
    otherPicksLabel: {
      fontSize: 10,
      fontWeight: '800',
      color: theme.primary,
      textTransform: 'uppercase',
      letterSpacing: 0.8,
    },
    otherPickRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: theme.background.cardElevated,
      borderRadius: 10,
      paddingVertical: 8,
      paddingHorizontal: 10,
      borderWidth: 1,
      borderColor: theme.gray[300],
      marginBottom: 0,
      ...(Platform.OS === 'web'
        ? makeBoxShadow({
            shadowColor: theme.primary,
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.04,
            shadowRadius: 2,
          })
        : {
            shadowColor: theme.primary,
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.04,
            shadowRadius: 2,
            elevation: 1,
          }),
    },
    otherPickRowLast: {
      marginBottom: 0,
    },
    otherPickMarket: {
      fontSize: 11,
      color: theme.gray[600],
      fontWeight: '600',
      flex: 1,
      marginRight: 8,
    },
    otherPickValueOdd: {
      fontSize: 12,
      fontWeight: '800',
      color: theme.accentDark,
    },
  };
}
